const FINAL_DELETE_STATES = new Set(['failed', 'unknown']);

export const telegramDeleteStatus = message =>
  message?.content_attributes?.tg_delete_status ??
  message?.contentAttributes?.tgDeleteStatus;

export const isTelegramDeletionConfirmed = message =>
  Boolean(
    message?.content_attributes?.deleted ?? message?.contentAttributes?.deleted
  );

export const shouldAcceptTelegramDeleteUpdate = (current, incoming) => {
  if (!current || !incoming) return true;
  if (isTelegramDeletionConfirmed(current)) {
    return isTelegramDeletionConfirmed(incoming);
  }
  if (telegramDeleteStatus(current) !== 'stale') return true;
  return (
    isTelegramDeletionConfirmed(incoming) ||
    FINAL_DELETE_STATES.has(telegramDeleteStatus(incoming))
  );
};

const timeoutMessage = message => {
  const attributes = {
    ...(message?.content_attributes || {}),
    tg_delete_status: 'stale',
  };
  return {
    ...message,
    attachments: [],
    content_attributes: attributes,
  };
};

export const reconcileTelegramDeletion = async ({
  api,
  conversationId,
  messageId,
  initialMessage,
  attempts = 12,
  delay = milliseconds =>
    new Promise(resolve => {
      window.setTimeout(resolve, milliseconds);
    }),
  intervalMs = 1000,
}) => {
  const refresh = async (remaining, latest) => {
    if (remaining <= 0) return timeoutMessage(latest);
    await delay(intervalMs);
    try {
      const response = await api.getPreviousMessages({
        conversationId,
        after: messageId,
        before: messageId + 1,
      });
      const refreshed = response.data?.payload?.find(
        message => Number(message.id) === Number(messageId)
      );
      if (!refreshed) return refresh(remaining - 1, latest);
      if (
        isTelegramDeletionConfirmed(refreshed) ||
        FINAL_DELETE_STATES.has(telegramDeleteStatus(refreshed))
      ) {
        return refreshed;
      }
      return refresh(remaining - 1, refreshed);
    } catch {
      // A short API interruption must not turn a successful Telegram delete
      // into a second delete request. The next bounded read is safe.
      return refresh(remaining - 1, latest);
    }
  };
  return refresh(attempts, initialMessage);
};
